function datetimepicker() {
    $(function () {
        $('#signaturedate').datetimepicker({
            format: 'YYYY-MM-DD HH:mm:ss'
        });
        $('#commentTimer').datetimepicker({
            format: 'YYYY-MM-DD HH:mm:ss'
        });
        $('#meetingDate').datetimepicker({
            format: 'YYYY-MM-DD HH:mm:ss'
        });
    });
}
